import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';

import { testId } from 'ui-components/services/testid-service';
import { Checkbox } from 'ui-components/components/checkbox';

import { MarkAsShippedContext } from '../../../context';
import { MARK_AS_SHIPPED_NOTIFY_MARKETPLACE } from '../../../constants';
import { stopPropagation } from '../../../helper';

import style from '../style.module.less';

const NotifyMarketplace = ({ fulfillmentPlanId }) => {
  const {
    fulfillmentPlans: { [fulfillmentPlanId]: { notifyMarketplace, disableNotifyMarketplace } = {} },
    updateFulfillmentPlan,
  } = useContext(MarkAsShippedContext);

  const onClick = useCallback(() => {
    updateFulfillmentPlan(fulfillmentPlanId, MARK_AS_SHIPPED_NOTIFY_MARKETPLACE, !notifyMarketplace);
  }, [updateFulfillmentPlan, fulfillmentPlanId, notifyMarketplace]);

  return (
    <div className={style.checkbox} {...testId('mark-as-shipped-notify-marketplace')} onClick={stopPropagation}>
      <Checkbox checked={!disableNotifyMarketplace && notifyMarketplace} disabled={disableNotifyMarketplace} onChange={onClick} />
    </div>
  );
};

NotifyMarketplace.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default NotifyMarketplace;
